import { gql } from '@apollo/client'

export const CHECK_PASSWORD = gql`
  query checkPassword($id: String!, $salasana: String!) {
    testPassword(id: $id, salasana: $salasana)
  }
`
